import { NgModule } from '@angular/core';
import { MatSidenavModule, MatToolbarModule, MatMenuModule, MatDialogModule } from '@angular/material';

@NgModule({
  declarations: [],
  imports: [
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatDialogModule
  ],
  exports: [
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatDialogModule
  ]
})
export class MaterialLayoutModule { }
